import { createGtm } from '@gtm-support/vue-gtm'
import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'

import eventSender from '@last/core-ui/scripts/eventSender'

import App from './App.vue'
import i18n from './i18n'
import router from './router'
import rum from './rum'
import { useAuthStore } from './store/auth'
import { useBookingStore } from './store/booking'
import { useConfigStore } from './store/config'
import { pinia } from './store/pinia'

import './style.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(i18n)
app.use(router)
app.use(pinia)

rum.setRouter(router)
if (import.meta.env.PROD) {
  app.config.errorHandler = err => {
    rum.addError(err)
  }
}

app.mount('#app')

async function init() {
  await router.isReady()

  const authStore = useAuthStore(pinia)
  const configStore = useConfigStore(pinia)
  const bookingStore = useBookingStore(pinia)

  authStore.setLocationId(router.currentRoute.value.params.locationId as string)

  // We want to show the i18n keys to help with translations
  if (router.currentRoute.value.query.translate === 'true') {
    i18n.global.locale.value = ''
    i18n.global.fallbackLocale.value = ''
  }

  const bookingId = router.currentRoute.value.params?.bookingId
  if (bookingId) {
    bookingStore.setBookingId(bookingId as string)
  }

  const organizationId = router.currentRoute.value.params?.organizationId
  if (organizationId) {
    authStore.setOrganizationId(organizationId as string)
  }

  await Promise.all([
    authStore.getOrganizationLocations(),
    authStore.getLocationInfo(),
    configStore.getLocationConfig(),
    bookingStore.getBookingInfo()
  ])

  if (authStore.scripts?.googleTagManagerId) {
    app.use(
      createGtm({
        id: authStore.scripts.googleTagManagerId
      })
    )
  }

  await eventSender.load(authStore.scripts, router)
}

init()
